function initMobileMenu() {
  // Get required elements
  const triggerElement = document.querySelector('.mobile-menu-trigger');
  const headerElement = document.querySelector('.header');

  // Add opening function
  triggerElement.addEventListener('click', () => {
    triggerElement.classList.toggle('open-mobile-menu');
    headerElement.classList.toggle('open-mobile-menu');
  });
}

export default initMobileMenu;
